const menuBarProps = {
	logo: {
		src: "https://production-azent-website-cms-uploads.s3.ap-south-1.amazonaws.com/azent_logo_transparent_c8670c3f18.png",
		title: "Azent Overseas Education",
		alternativeText: "Azent Overseas Education",
	},
};

export { menuBarProps };
